import {
    Button,
    Card,
    Col,
    Collapse,
    DatePicker,
    Divider,
    Form,
    Input,
    message,
    Modal,
    Pagination,
    Row,
    Select,
    Space,
    Spin,
    Table,
    Tag
} from "antd";
import {CloseOutlined, DownloadOutlined, EyeOutlined} from "@ant-design/icons";
import React, {useEffect, useRef, useState} from "react";

import dayjs from "dayjs";
import CommonFunction from "../../../../util/CommonFunction";
import {
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_SIGNATURE_CHANGE_DETAILS_HISTORY_ERROR
} from "../../../../util/Messages";
import {ChangeRequestFilterDto} from "../../../../dto/admin/ChangeRequestFilterDto";
import {
    CHANGE_REQUEST_RECORD_STATUS,
    DOCUMENT_TYPES,
    NOT_AVAILABLE,
    YYYY_MM_DD,
    YYYY_MM_DD_HH_MM
} from "../../../../util/Constants";
import {AddressDto} from "../../../../dto/AddressDto";
import ErrorHandler from "../../../../util/ErrorHandler";
import documentService from "../../../../service/documentService";
import {DefaultDocumentDto} from "../../../../dto/DefaultDocumentDto";
import {UploadedDocumentDetailDto} from "../../../../dto/UploadedDocumentDetailDto";
import customerChangeRequestAdminService from "../../../../service/customerChangeRequestAdminService";
import TextArea from "antd/es/input/TextArea";
import PreviewModalComp from "../../../common/preview/PreviewModalComp";
import {SignatureDto} from "../../../../dto/SignatureDto";

const {Panel} = Collapse;
const {RangePicker} = DatePicker;

const SignatureDetailChangeHistoryComp = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [isModalLoading, setModalLoading] = useState<boolean>(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 10,
    });

    const [filter, setFilter] = useState<ChangeRequestFilterDto>({
        recordStatus: null,
        submittedDateTo: null,
        submittedDateFrom: null,
        cin: null,
        page: 1,
        size: 10,
        sort: ['createdDate', 'desc']
    });
    const [docURL, setDocURL] = useState('');
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewTitle, setPreviewTitle] = useState('');
    const [isShowRejectReason, setCanShowRejectReason] = useState<boolean>(false)
    const [signatureDetailChangeHistoryList, setSignatureDetailChangeHistoryList] = useState<AddressDto[]>()
    const [signatureChangeDocument, setSignatureChangeDocument] = useState<DefaultDocumentDto[]>()

    const [form] = Form.useForm();


    const [position2, setPosition2] = useState({x: 100, y: 20});
    const modalRef2 = useRef<HTMLDivElement | null>(null);
    const draggingRef2 = useRef<{ offsetX: number; offsetY: number } | null>(null);

    const onMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        if ((e.target as HTMLElement).classList.contains('draggable-modal-title-area')) {
            if (modalRef2.current) {
                const rect = modalRef2.current.getBoundingClientRect();
                draggingRef2.current = {offsetX: e.clientX - rect.left, offsetY: e.clientY - rect.top};
            }
        }
    };

    // Drag the modal
    const onMouseMove = (e: MouseEvent) => {
        if (draggingRef2.current) {
            const {offsetX, offsetY} = draggingRef2.current;
            setPosition2({x: e.clientX - offsetX, y: e.clientY - offsetY});
        }
    };

    // Stop dragging
    const onMouseUp = () => {
        draggingRef2.current = null;
    };

    useEffect(() => {
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        return () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
    }, []);
    useEffect(() => {
        fetchAllSignatureChangeHistoryList(pagination.current, pagination.pageSize, filter)

    }, []);

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'CIN',
            dataIndex: 'cin',
            key: 'cin',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Created By',
            dataIndex: 'createdBy',
            key: 'createdBy',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Created Date Time',
            dataIndex: 'createdDate',
            key: 'createdDate',
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Modified By',
            dataIndex: 'lastModifiedBy',
            key: 'lastModifiedBy',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Modified Date Time',
            dataIndex: 'lastModifiedDate',
            key: 'lastModifiedDate',
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Status',
            dataIndex: 'recordStatus',
            key: 'recordStatus',
            align: 'center',
            render: (text: any, rec: any) => {
                return (
                    <Tag className={'drl-tbl-tag'}
                         color={getColor(text)} key={text}>
                        {text.toUpperCase()}
                    </Tag>
                )
            }
        },
        {
            title: 'Action',
            key: 'action',
            align: "center",
            fixed: 'right' as const,
            render: (rec: any) => (
                <Space size="middle">
                    <Button className='btn-action-outline-common btn-action-view '
                            onClick={() => fetchSignatureChangeHistoryDetail(rec.cin, rec.id)}
                            icon={<EyeOutlined/>}>View</Button>
                </Space>
            ),
        },
    ];
    const fetchSignatureChangeHistoryDetail = (cin: string, id: number) => {
        setLoading(true)

        customerChangeRequestAdminService.getSignatureChangeRequestDetails(cin, id).then((res => {
            if (res.data !== null && res.data.results) {
                console.log(res.data.results)
                showModal(res.data.results)
                setLoading(false)
            } else {
                setLoading(false)
                message.error(MSG_FAILED_TO_FETCH_SIGNATURE_CHANGE_DETAILS_HISTORY_ERROR).then();
            }
        })).catch((reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        });
    }
    const showModal = (record: SignatureDto) => {
        setModalLoading(true)
        setFieldValues(record)

    };

    const getColor = (identificationSourceType: string) => {
        switch (identificationSourceType) {
            case CHANGE_REQUEST_RECORD_STATUS.ACCEPTED: {
                return 'green';
            }
            case CHANGE_REQUEST_RECORD_STATUS.SUBMITTED: {
                return '#faad14';
            }
            case CHANGE_REQUEST_RECORD_STATUS.REJECTED: {
                return '#cf1322';
            }
            case CHANGE_REQUEST_RECORD_STATUS.CANCELLED: {
                return '#dfd3d4';
            }
        }
    }

    const onReset = () => {
        form.resetFields();
        let filterDto: ChangeRequestFilterDto = {
            cin: null,
            recordStatus: null,
            submittedDateFrom: null,
            submittedDateTo: null,
            page: 1,
            size: pagination.pageSize,
            sort: filter.sort
        }
        setFilter(filterDto);
        setPagination({
            ...pagination,
            current: 1,
        });
        fetchAllSignatureChangeHistoryList(1, pagination.pageSize, filterDto);
    }
    const onFilter = (values: any) => {

        let submittedDateFrom = null
        let submittedDateTo = null

        if (values.createdDate) {
            submittedDateFrom = values.createdDate[0].format(YYYY_MM_DD)
            submittedDateTo = values.createdDate[1].format(YYYY_MM_DD)
        }

        let filterDto: ChangeRequestFilterDto = {
            cin: checkUndefined(values.cin),
            recordStatus: values.recordStatus,
            submittedDateFrom: submittedDateFrom,
            submittedDateTo: submittedDateTo,
            page: 1,
            size: pagination.pageSize,
            sort: filter.sort
        }
        setFilter(filterDto);
        fetchAllSignatureChangeHistoryList(1, pagination.pageSize, filterDto);
    }
    const checkUndefined = (value: any) => {
        return value == undefined || value == "" ? null : value
    }


    const setFieldValues = (signatureDto: SignatureDto) => {

        form.setFieldsValue({
            cin: CommonFunction.validateText(signatureDto.cin),
            jobNumber: CommonFunction.validateText(signatureDto.jobNumber),
            requestedDate: CommonFunction.validateText(signatureDto.requestedDate),
            requestedStartTime: CommonFunction.validateText(signatureDto.requestedStartTime),
            requestedEndTime: CommonFunction.validateText(signatureDto.requestedEndTime),
            recordStatus: CommonFunction.validateText(signatureDto.recordStatus),
            createdBy: CommonFunction.validateText(signatureDto.createdBy),
            createdDateTime: null != signatureDto.createdDateTime ? dayjs(signatureDto.createdDateTime).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE,
            modifiedBy: CommonFunction.validateText(signatureDto.modifiedBy),
            modifiedDate: CommonFunction.validateText(signatureDto.modifiedDate),
            videoLink: CommonFunction.validateText(signatureDto.videoLink),
            rejectReason: signatureDto.rejectReason
        })
        setCanShowRejectReason("REJECTED" == signatureDto.recordStatus)
        loadUploadedDocumentsById(signatureDto.jobNumber, signatureDto.signatureDocId,
            [signatureDto.recordStatus === "ACCEPTED" ? 'SIGN' : 'SIGN_TEMP'])
        setModalLoading(false)
        setIsModalOpen(true)
    }


    const handleCancel = () => {
        setPosition2({x: 100, y: 20});
        setIsModalOpen(false);
        setPreviewOpen(false);
        resetModalFormFields();
    };

    const resetModalFormFields = () => {
        form.resetFields()
    }

    const loadUploadedDocumentsById = (jobNo: number, docId: number, docTypeCode: string[]) => {
        documentService.getUploadDocumentListByTypeAndUploadedDocId(jobNo, docId, docTypeCode).then(res => {
            if (res.data !== null && res.data.results.length > 0) {
                createUploadedDocuments(res.data.results[0].uploadDocumentDetailDto, res.data.results[0].documentTypeId)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        });
    };


    const createUploadedDocuments = (uploadDocumentDetailDtoList: UploadedDocumentDetailDto, documentTypeId: number) => {
        let defaultFileList;
        if (undefined != uploadDocumentDetailDtoList) {
            defaultFileList =
                [{
                    uid: uploadDocumentDetailDtoList.uploadDocumentDetailId.toString(),
                    name: uploadDocumentDetailDtoList.originalDocumentName,
                    thumbUrl: uploadDocumentDetailDtoList.thumbB64,
                    url: uploadDocumentDetailDtoList.thumbDocumentPath
                }]
        } else {
            defaultFileList = undefined;
        }

        if (documentTypeId == DOCUMENT_TYPES.SIGN || documentTypeId == DOCUMENT_TYPES.SIGN_TEMP) {
            setSignatureChangeDocument(defaultFileList)
            // form.setFieldsValue({uploadUtilityBill: defaultFileList})
        }
    }
    const fetchAllSignatureChangeHistoryList = (page: number, pageSize: number, filterDto: ChangeRequestFilterDto) => {
        setLoading(true)

        filterDto.page = page - 1;
        filterDto.size = pageSize;

        customerChangeRequestAdminService.signatureChangeRequestHistory(filterDto).then((res => {
            if (res.data !== null && res.data.results) {
                let results = res.data.results;
                setSignatureDetailChangeHistoryList(results.requestAdminHistoryDtos)
                setPagination({
                    current: results.page + 1, // Adjusting to be 1-based index
                    pageSize: results.size,
                    total: results.allCount,
                });
                setLoading(false)
            } else {
                setLoading(false)
                message.error(MSG_FAILED_TO_FETCH_SIGNATURE_CHANGE_DETAILS_HISTORY_ERROR).then();
            }
        })).catch((reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        });
    }

    const openModal = (documentId: string, docTypeName: string) => {
        setLoading(true)
        documentService.viewOriginalDocument(documentId).then(res => {
            if (res.data !== null) {
                setPosition2({x: 100, y: 20});
                setPreviewOpen(true);
                setIsModalOpen(true);
                setPreviewTitle(docTypeName);
                setDocURL(res.data.results)
                setLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setLoading(false)
            }
        }, (reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        })
        return true;
    };
    const handlePreviewCancel = () => {
        setPreviewOpen(false);
    };
    const download = (val: string, docName: string) => {
        let a = document.createElement('a');
        a.href = val;
        a.download = docName;
        a.click();
    }
    const handlePaginationChange = (page: number, pageSize: number) => {
        fetchAllSignatureChangeHistoryList(page, pageSize, filter);
    };

    return (
        <>
            <Row gutter={[24, 12]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Collapse className={'margin_bottom_20'}>
                        <Panel header="Filter History" key="1">
                            <Form
                                layout={"vertical"}
                                form={form}
                                onFinish={onFilter}
                            >
                                <Row gutter={[16, 0]}>
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item name="cin" label="CIN">
                                            <Input placeholder={'Enter CIN'}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item name="recordStatus" label="Status">
                                            <Select style={{width: '100%'}} defaultValue="All"
                                                    options={[
                                                        {value: null, label: 'All'},
                                                        {value: 'ACCEPTED', label: 'Accepted'},
                                                        {value: 'REJECTED', label: 'Rejected'},
                                                        {value: 'CANCELLED', label: 'Cancelled'}]}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item label="Created Date" name="createdDate">
                                            <RangePicker placeholder={["From Date", "To Date"]}
                                                         style={{width: '100%'}}/>

                                        </Form.Item>
                                    </Col>

                                </Row>
                                <Row gutter={[16, 0]}>
                                    <Col span={24}>
                                        <Space style={{float: 'right'}}>
                                            <Button style={{
                                                width: 120,
                                                marginRight: 8
                                            }} onClick={onReset}>Reset</Button>
                                            <Button type="success"
                                                    htmlType="submit"
                                                    style={{
                                                        width: 120,
                                                        background: "#FF7400",
                                                        color: "white",
                                                    }}>Filter</Button>
                                        </Space>
                                    </Col>
                                </Row>
                            </Form>
                        </Panel>
                    </Collapse>
                </Col>
                <Col span={24}>
                    <Table columns={columns} dataSource={signatureDetailChangeHistoryList} pagination={false}
                           loading={loading}
                           scroll={{x: 'max-content'}}/>
                    <br/>
                    <Space style={{float: 'right'}}>
                        <Pagination
                            total={pagination.total ?? 0}
                            showTotal={(total: number) => `Total ${total} items`}
                            defaultPageSize={10}
                            defaultCurrent={pagination.current}
                            current={pagination.current}
                            onChange={handlePaginationChange}
                        />
                    </Space>
                </Col>
                <Modal
                    title={'Signature Update Request History'}
                    style={{top: 0, right: 0, margin: 20, marginTop: 20, position: 'absolute'}}
                    maskStyle={{top: 0, left: 0}}
                    open={isModalOpen} footer={null} onCancel={handleCancel} maskClosable={false}
                    className={'modal-body-scroll-only disabled-data-show-inputs-container'}
                    width={'50vw'}
                >
                    <Spin spinning={isModalLoading}>


                        <Row gutter={[24, 12]}
                             className={'form-item-mb-12 modal-body-scroll-only-main-row compare-modal-height'}>

                            <Col span={24}>
                                <Card title="Signature Details" size={'small'}>
                                    <Form
                                        className='form-input'
                                        layout={"vertical"}
                                        form={form}
                                        disabled
                                    >
                                        <Row gutter={[12, 0]}>
                                            <Col span={8}>
                                                <Form.Item
                                                    label="CIN"
                                                    name={"cin"}>
                                                    <Input/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    label="Job Number"
                                                    name={"jobNumber"}>
                                                    <Input/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    label="Requested Date"
                                                    name={"requestedDate"}>
                                                    <Input/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    label="Request Start Time"
                                                    name={"requestedStartTime"}>
                                                    <Input/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    label="Request End Time"
                                                    name={"requestedEndTime"}>
                                                    <Input/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    label="Record Status"
                                                    name={"recordStatus"}>
                                                    <Input/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    label="Created By"
                                                    name={"createdBy"}>
                                                    <Input type="text"/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    label="Created Date Time"
                                                    name={"createdDateTime"}>
                                                    <Input type="text"/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    label="Modified By"
                                                    name={"modifiedBy"}>
                                                    <Input type="text"/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    label="Modified Date Time"
                                                    name={"modifiedDate"}>
                                                    <Input type="text"/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                {/*<Form.Item*/}
                                                {/*    label="Video Link"*/}
                                                {/*    name={"videoLink"}>*/}
                                                {/*    <Input type="text"/>*/}
                                                {/*</Form.Item>*/}
                                            </Col>

                                            <Col span={12}>
                                                <Form.Item className={'form-item-label-only'}
                                                           label="Signature">
                                                </Form.Item>

                                                <div className='utility_bill img-nic' style={{width: '94%'}}>
                                                    <div className='utulity_bill_icon_div'>
                                                        <div className="img_div">
                                                            <img
                                                                src={signatureChangeDocument ? signatureChangeDocument[0].thumbUrl : ''}
                                                                alt=""/>
                                                        </div>
                                                        <div className='name_div'>
                                                            <h5>{signatureChangeDocument ? signatureChangeDocument[0].name : ''}</h5>
                                                        </div>
                                                    </div>
                                                    <Button disabled={false}
                                                            onClick={() => openModal(
                                                                signatureChangeDocument ? signatureChangeDocument[0].uid : '',
                                                                signatureChangeDocument ? signatureChangeDocument[0].name : '')}
                                                            className='doc-view-btn'><EyeOutlined/></Button>
                                                </div>

                                            </Col>
                                            {isShowRejectReason ?
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <Divider></Divider>

                                                    <Form.Item

                                                        name={"rejectReason"}
                                                        label={"Reject Reason"}>
                                                        <TextArea disabled bordered={true}/>
                                                    </Form.Item>
                                                </Col>
                                                :
                                                <></>
                                            }
                                        </Row>
                                    </Form>
                                </Card>
                            </Col>


                        </Row>
                    </Spin>
                </Modal>

                {previewOpen &&
                    <div
                        ref={modalRef2}
                        className="draggable-modal"
                        style={{
                            position: 'fixed',
                            top: position2.y,
                            left: position2.x,
                            zIndex: 100000,
                            width: '40vw'
                        }}
                        onMouseDown={onMouseDown}
                    >
                        <div className="draggable-modal-title-area">
                            <span className={'modal-title'}>{previewTitle}</span>
                            <Button icon={<CloseOutlined/>} size={'small'} onClick={handlePreviewCancel}/>
                        </div>
                        <div className="modal-body-area compare-preview-modal-height">
                            <PreviewModalComp docURL={docURL}/>
                        </div>
                        <div className="modal-footer-area">
                            <Button type="primary" icon={<DownloadOutlined/>}
                                    style={{background: '#FF7400', height: 40}}
                                    htmlType="submit" onClick={() => download(docURL, previewTitle)}>
                                Download
                            </Button>
                        </div>
                    </div>
                }

            </Row>

        </>
    )
}
export default SignatureDetailChangeHistoryComp;